import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEffect = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 73,
	height: 48,
	viewBox: "0 0 73 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		opacity: .3,
		filter: "url(#filter0_f_4633_20676)",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 12,
			r: 38,
			fill: "url(#paint0_radial_4633_20676)"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_f_4633_20676",
		x: -35,
		y: -42,
		width: 108,
		height: 108,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "BackgroundImageFix",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 8,
				result: "effect1_foregroundBlur_4633_20676"
			})
		]
	}), /* @__PURE__ */ _jsxs("radialGradient", {
		id: "paint0_radial_4633_20676",
		cx: 0,
		cy: 0,
		r: 1,
		gradientUnits: "userSpaceOnUse",
		gradientTransform: "translate(19 12) rotate(90) scale(38)",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E0FDFF" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "white",
			stopOpacity: .04
		})]
	})] })]
});
export default SvgEffect;
